export function NotFoundPage() {
  return (
    <main className="boot">
      <div className="panel stack">
        <h1>Halaman tidak ditemukan</h1>
        <p className="muted">Alamat yang Anda buka tidak tersedia.</p>
        <a href="/">Kembali ke beranda</a>
      </div>
    </main>
  );
}
